export default {
	list: 'Investment',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentID: {
			class: 'value',
			dataName: 'InvestmentID',
			type: 'number',
			title: 'Investment ID',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Investment Name',
			width: 200,
			hidden: false,
			readOnly: false,
		},
		InvestmentGroup: {
			class: 'choice',
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 200,
			hidden: false,
			readOnly: false
		},
		StatementOrder: {
			class: 'value',
			dataName: 'StatementOrder',
			type: 'number',
			title: 'Statement Order',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 200,
			hidden: false,
			readOnly: false
		},
		ShowOnFMVS: {
			class: 'choice',
			dataName: 'ShowOnFMVS',
			type: 'string',
			title: 'Show on FMVS',
			width: 150,
			hidden: false,
			readOnly: false
		},
		HideNumberOnFMVS: {
			class: 'choice',
			dataName: 'HideNumberOnFMVS',
			type: 'string',
			title: 'Hide Number on FMVS',
			width: 150,
			hidden: false,
			readOnly: false
		},
	}
}